<script lang="ts" setup>
	defineProps<{
		src: string | null
		wrapperClass?: string
	}>()
	const isOpen = shallowRef(false)
	const toggle = () => (isOpen.value = !isOpen.value)
</script>

<template>
	<div>
		<div class="custom-transition-2 overflow-hidden" :class="[isOpen ? 'max-h-[1000px]' : 'max-h-[0]']">
			<img
				:src="src as string"
				class="max-h-[260px] w-full max-w-[260] rounded-lg object-cover object-top"
				alt="hmo preview"
				loading="lazy"
				:height="200"
				:width="200"
			/>
		</div>
		<div class="mt-5 flex h-[60px] items-center justify-between rounded-lg p-5 text-base" :class="wrapperClass">
			<div class="flex items-center gap-x-3">
				<lazy-tools-icon icon="gallery" dir="media" :height="32" :width="32" />
				<span class="font-medium text-gray-600">IMG</span>
			</div>

			<button class="custom-transition-2 font-semibold text-primary-2" @click="toggle">
				{{ isOpen ? 'Close Preview' : 'Preview' }}
			</button>
		</div>
	</div>
</template>
